import * as Yup from 'yup';

export const formSchemaPN = (defaultPhoneNo?: string) => [
  {
    name: 'phoneNumber',
    defaultValue: defaultPhoneNo || '',
    validate: Yup.string()
      .required('Vui lòng nhập số điện thoại')
      .min(10, 'Số điện thoại không hợp lệ'),
  },
];

export const formSchemaOTP = [
  {
    name: 'otp',
    validate: Yup.string().required('Vui lòng nhập mã xác thực'),
  },
];
